import { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHeader, TableSkeleton } from "@/components/helpers";
import { PeriodeSelector } from "@/components/dashboards/commun";
import { DashVendeur } from "@/components/dashboards/DashVendeur";
import { DashConseiller } from "@/components/dashboards/DashConseiller";
import { DashChef } from "@/components/dashboards/DashChef";
import { DashDirecteur } from "@/components/dashboards/DashDirecteur";
import { DashDG } from "@/components/dashboards/DashDG";
import { DashSecretaire } from "@/components/dashboards/DashSecretaire";
import { Button } from "@/components/ui/button";

const SOUS_TITRES = {
  vendeur: "Mon activité commerciale",
  conseiller_service: "Activité atelier du jour",
  chef_ventes: "Pilotage de l'équipe commerciale",
  directeur: "Vue 360° du site",
  dg: "Consolidation multi-sites",
  secretaire_commerciale: "File de travail — dossiers administratifs",
};

export default function Dashboard() {
  const { auth } = useAuth();
  const [periode, setPeriode] = useState("mois");
  const [drill, setDrill] = useState(null);
  const [d, setD] = useState(null);

  useEffect(() => {
    setD(null);
    let url = `/dashboard?periode=${periode}`;
    if (drill) url += `&vue=directeur&site=${encodeURIComponent(drill)}`;
    api.get(url).then((r) => setD(r.data)).catch(() => setD({ role: "erreur", kpis: {}, widgets: {} }));
  }, [periode, drill]);

  const prenom = (auth?.user?.nom || "").split(" ")[0];

  if (d?.role === "invite") {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="dash-invite">
        <h1 className="text-xl font-bold">Bienvenue sur ID Core</h1>
        <p className="text-[13.5px] text-[--idc-muted] mt-2 max-w-md">{d.message}</p>
      </div>
    );
  }

  return (
    <div data-testid="page-dashboard">
      <PageHeader
        title={drill ? `Tableau de bord — ${drill}` : `Bonjour ${prenom} 👋`}
        subtitle={drill ? "Vue site (lecture) — consolidation DG" : SOUS_TITRES[d?.role] || "Tableau de bord"}
        actions={
          <div className="flex items-center gap-2">
            {drill && (
              <Button size="sm" variant="outline" onClick={() => setDrill(null)} data-testid="dash-retour-groupe-btn">
                <ArrowLeft className="w-4 h-4 mr-1.5" /> Retour au groupe
              </Button>
            )}
            <PeriodeSelector value={periode} onChange={setPeriode} />
          </div>
        }
      />
      {!d ? <TableSkeleton rows={6} cols={4} /> : (
        <>
          {d.role === "vendeur" && <DashVendeur d={d} />}
          {d.role === "conseiller_service" && <DashConseiller d={d} />}
          {d.role === "chef_ventes" && <DashChef d={d} />}
          {d.role === "directeur" && <DashDirecteur d={d} />}
          {d.role === "dg" && <DashDG d={d} onDrill={setDrill} />}
          {d.role === "secretaire_commerciale" && <DashSecretaire d={d} />}
          {d.role === "erreur" && <p className="text-[13px] text-[--idc-muted]">Impossible de charger le tableau de bord.</p>}
        </>
      )}
    </div>
  );
}
